import { useMutation } from '@tanstack/react-query';
import saveAs from 'save-as';

import { useToast } from 'Store/toast';
import { useLoader } from 'Store/loader';

import { exportScheduleText } from 'Const/schedule';
import getExportSchedule from 'Api/schedule/getExportSchedule';

const useGetExportSchedule = () => {
  const { onOpenToast } = useToast();
  const { onShowLoader, onResetLoader } = useLoader();

  return useMutation({
    mutationFn: async ({ month, year }) => {
      onShowLoader({ variant: 'loader-primary' });

      return await getExportSchedule({ month, year });
    },
    onSuccess: (response) => {
      const filename = 'Schedule Data.xlsx';

      const blob = new Blob([response.data]);

      saveAs(blob, filename);

      onOpenToast({
        status: 'success',
        description: exportScheduleText?.successExportScheduleText,
        duration: 3,
        alwaysShow: false,
      });
    },
    onError: (error) => {
      console.log(error);

      onOpenToast({
        status: 'error',
        description: exportScheduleText?.failedExportScheduleText,
        duration: 5,
        alwaysShow: false,
      });
    },
    onSettled: () => {
      onResetLoader();
    },
  });
};

export default useGetExportSchedule;
